import React from "react";
import "./stylesheets/floating.css";
import NorthIcon from '@mui/icons-material/North';

const ScrollToTop = () => {
	return (
		<div
			id="ScrollToTop"
			onClick={() => window.scrollTo({ top: "0px", behaviour: "smooth" })}
		>
			<NorthIcon/>
		</div>
	);
};

export default ScrollToTop;
